export default "__VITE_ASSET__Bw1HUcVG__"